/* global axios */

import ApiClient from './ApiClient';

class CostReportsAPI extends ApiClient {
  constructor() {
    super('cost_reports', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new CostReportsAPI();
